import {Component, EventEmitter, HostBinding, HostListener, Input, Output} from '@angular/core';

@Component({
  selector: 'app-report-table-header-column',
  templateUrl: './report-table-header-column.component.html',
  styleUrls: ['./report-table-header-column.component.scss']
})
export class ReportTableHeaderColumnComponent {
  @Input() public name: string;
  @Input() public column: string;

  public enableSort: boolean = false;
  @Input('enableSort') private set _enableSort(enable: boolean) {
    this.enableSort = enable || false;
    this.enabledClass = this.enableSort;
  }

  @Output() public onSort: EventEmitter<{ column: string, order: 'asc' | 'desc' | 'none' }> = new EventEmitter<{ column: string, order: 'asc' | 'desc' | 'none' }>();

  @HostBinding('class.enabled') public enabledClass = this.enableSort;

  private readonly _sortOrders: Array<'asc' | 'desc' | 'none'> = ['none', 'asc', 'desc'];

  public sortOrder: 'asc' | 'desc' | 'none' = this._sortOrders[0];
  public sortEnabled: boolean = false;

  constructor() {}

  private _sort(): void {
    const index: number = this._sortOrders.indexOf(this.sortOrder) + 1;
    const order: 'asc' | 'desc' | 'none' = this._sortOrders[index] || this._sortOrders[0];

    this.sortEnabled = true;
    this.sortOrder = order;
    this.onSort.emit({ column: this.column, order: order });
  }

  public reset(): void {
    this.sortOrder = 'none';
  }

  @HostListener('click', ['$event']) onClick(): void {
    this._sort();
  }
}
